import React, { Component } from 'react';
import { connect } from 'react-redux';

import HelpPage from './HelpPage';
import { resetHelp } from 'actions/help';
import { wrapAppWithCssClass } from 'decorators/wrapAppWithClass';
import { StoreProps } from 'store';

interface OwnProps {
  // isSearchResults: boolean;
}

interface ConnectedProps {
  isFetched: boolean;
}

type Props = OwnProps & ConnectedProps & StoreProps;

@wrapAppWithCssClass('layout-app_tablet-width')
class HelpContainer extends Component<Props> {
  render() {
    const { isFetched } = this.props;
    return <HelpPage isFetched={isFetched} />;
  }
  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(resetHelp());
  }
}

const mapStateToProps = (state) => ({
  isFetched: state.help.isFetched,
});

export default connect(mapStateToProps)(HelpContainer);
